import React from "react";
import { Grid, Typography } from "@mui/material";
import ModelCard from "./ModelCard";

export default function ModelCardGrid({
    models,
    onEdit,
    onDelete,
    onPreview,
    onCreateDesign,
    onRename,
}) {
    if (!models.length) {
        return (
            <Typography color="text.secondary">
                Aucun modèle trouvé. Créez votre premier modèle.
            </Typography>
        );
    }

    return (
        <Grid container spacing={2}>
            {models.map((model) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={model._id}>
                    <ModelCard
                        model={model}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onPreview={onPreview}
                        onCreateDesign={onCreateDesign}
                        onRename={onRename}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
